import {
  Box,
  Button,
  Link,
  ModalBody,
  Stack,
  Text,
  UseDisclosureReturn,
} from '@chakra-ui/react'

import Modal from '@/components/atoms/Modal'
import { ModalHeader, Span } from '@/components/atoms/shared'

import { PackageSize } from '@/features/dashboard/packages/types'

type ConfirmSelectUserModalProps = {
  disclosure: UseDisclosureReturn
  isLoading: boolean
  onSubmit: () => void
  packageName: PackageSize
  quota: number
}

export const ConfirmSelectUserModal = (props: ConfirmSelectUserModalProps) => {
  const { disclosure, packageName, quota, isLoading, onSubmit } = props
  const { isOpen, onClose } = disclosure

  return (
    <Modal isOpen={isOpen} onClose={onClose} withCloseButton>
      <ModalHeader>
        ยืนยันการเลือกผู้ใช้
        <Text sx={{ fontSize: 'md', fontWeight: 'normal' }}>
          ปัจจุบันคุณใช้&nbsp;
          <Span sx={{ fontWeight: 'semibold' }}>
            แพ็กเกจ {packageName.toTitleCase()}
          </Span>
          <br />
          รองรับผู้ใช้งานได้สูงสุดจำนวน {quota} คน
        </Text>
      </ModalHeader>

      <ModalBody>
        <Box>
          <Text
            sx={{
              textDecor: 'underline',
              fontWeight: 'bold',
              color: 'red.400',
            }}
          >
            ข้อควรระวัง
          </Text>
          <Text
            sx={{
              color: 'red.400',
            }}
          >
            ข้อมูลทั้งหมดของผู้ใช้ที่คุณไม่ได้เลือกจะถูกระงับการใช้งานและ
            ถูกยกเลิกการมอบหมายการดูแลคำร้องทั้งหมด หากต้องการให้ผู้ใช้งาน
            ทั้งหมดสามารถใช้งานได้ปกติ กรุณา&nbsp;
            <Link sx={{ color: 'brand.400' }} href="/packages">
              อัปเกรดแพ็กเกจ
            </Link>
          </Text>

          <Text sx={{ mt: 6 }}>หากคุณตรวจทานเรียบร้อยแล้ว กดยืนยัน</Text>
        </Box>

        <Stack mt="6">
          <Button size="xl" isLoading={isLoading} onClick={onSubmit}>
            ยืนยัน
          </Button>
          <Button
            size="xl"
            colorScheme="gray"
            variant="ghost"
            isDisabled={isLoading}
          >
            ยกเลิก
          </Button>
        </Stack>
      </ModalBody>
    </Modal>
  )
}
